import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import {connect} from 'react-redux';
import {MessageFormat, DynamicComponent, gaMailingFunctionMap} from './Constant';
import {setShowPopUp} from './UpdateMailingMethodSlice';
import EpiContext from '@episerver/spa-core/Spa';
import Config from '../../../Config';
import {dwhMailingMethod} from './dwhReport';

function UpdateMailingMessage({messageContent, setShowPopUp, dwhParams, selectedBan, currentMethod}) {
  const Description = messageContent ? DynamicComponent[messageContent.description] : '';

  useEffect(() => {
    gaMailingFunctionMap[messageContent.gaFunction]();
    dwhMailingMethod({
      ...dwhParams,
      status: messageContent.status,
      message: messageContent.reporterMessage,
      ban: selectedBan.join(';'),
      param3: currentMethod,
    });
  }, []);

  const handleSubmit = () => {
    if (messageContent.format == MessageFormat.PopUp) {
      setShowPopUp(false);
    } else {
      EpiContext.navigateTo(Config.lobbyUrl);
    }
  };

  return (
    <div className={`UpdateMailingMessage ${messageContent.format == MessageFormat.PopUp ? 'popup' : 'page'}`}>
      <Image className='icon' src={messageContent.icon} />
      <p className='title' dangerouslySetInnerHTML={{__html: messageContent.title}} />
      <p className='subTitle' dangerouslySetInnerHTML={{__html: messageContent.subTitle}} />
      {messageContent.description && <Description />}
      {messageContent.buttonText && <BtnSubmit text={messageContent.buttonText} onclick={() => handleSubmit()}></BtnSubmit>}
    </div>
  );
}

const mapStateToProps = (state) => ({
  messageContent: state.updateMailingMethod.messageContent,
  dwhParams: state.updateMailingMethod.dwhParams,
  currentMethod: state.updateMailingMethod.currentMethod,
  selectedBan: state.updateMailingMethod.selectedBan,
});

const mapDispatchToProps = {
  setShowPopUp,
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateMailingMessage);
